export var underline = {
    parseDOM: [{ tag: 'u' }, { style: 'text-decoration=underline' }],
    toDOM: function () { return ['span', { style: 'text-decoration:underline' }, 0]; },
};
